import _ from 'underscore'

const getters = {
  getErrorMessage: state => state.errorMessage,
  getCurrentStep: state => state.currentStep,
  isAdditionalQuestion: state => state.isAdditionalQuestion,
  getFollowUpQuestions: state => state.followUpQuestions,
  hasError: state => state.hasError,
  isLoading: state => state.isLoading,
  isComplete: state => state.isComplete,
  isMobile: state => state.isMobile,
  pullFactorsReceived: state => state.pullFactorsReceived,
  getAnswers: state => state.answers,
  getQuestions: state => state.questions,
  getPossibleFunctionNames: state => state.possibleFunctionNames,
  getQuestionTypes: state => state.questionTypes,
  getIntakeId: state => state.intakeId,
  getToken: state => state.token,
  getCurrentStepDescription: (state) => {
    return state.stepDescriptions[state.currentStep - 1] ? state.stepDescriptions[state.currentStep - 1] : null;
    /*return _.find(state.stepDescriptions, (stepDescription) => {
      let deviceType = state.isMobile ? 'mobile' : 'desktop'
      return +stepDescription.step === +state.currentStep && stepDescription.device_type === deviceType
    })*/
  },
  getPullFactorQuestions: (state) => {
    return _.filter(state.questions, (question) => {
      return question.type === 'function_name' ||
        question.type === 'experience' ||
        question.type === 'province' ||
        question.type === 'country'
    })
  },
  isPullFactorQuestion: () => (question) => {
    return question.type === 'function_name' ||
      question.type === 'experience' ||
      question.type === 'province' ||
      question.type === 'country'
  },

  getQuestionLabel: (state, getters) => (question) => {
    let selectedQuestionType = getters.getSelectedProfileQuestionType
    if (typeof selectedQuestionType !== 'undefined' && selectedQuestionType !== null) {
      let questionLabel = _.find(question.extraAttributes.questionLabels, (questionLabel) => {
        return +questionLabel.question_type_id === +selectedQuestionType.id
      })
      return questionLabel.label
    }

    return question.extraAttributes.questionLabels[0] ? question.extraAttributes.questionLabels[0].label : question.name;
  },
  getSelectedProfileQuestionType: (state, getters) => {
    let characterQuestion = _.find(getters.getQuestions, (question) => question.type === 'character')
    if (typeof characterQuestion !== 'undefined' && characterQuestion !== null) {
      let characterAnswer = getters.getAnswerByQuestionId(characterQuestion.id)
      if (typeof characterAnswer !== 'undefined') {
        return _.find(state.questionTypes, (questionType) => characterAnswer.value === questionType.name)
      }
    }

    return null
  },
  getOptionsByAnswer: (state, getters) => (answer) => {
    let question = getters.getQuestionByQuestionId(answer.question_id)
    let options = []
    if (typeof question.extraAttributes !== 'undefined') {
      options = _.filter(question.extraAttributes.questionOptions, (questionOption) => {
        if (Array.isArray(answer.value)) {
          return _.filter(answer.value, (answerValue) => answerValue === questionOption.option_value)
        }
        return answer.value === questionOption.option_value
      })
    }
    return options
  },
  getQuestionByQuestionId: (state) => (questionId) => _.find(state.questions, (question) => +question.id === +questionId),

  hasErrorByQuestionId: (state) => (questionId) => {
    let foundQuestions = state.wrongAnsweredQuestions.filter((wrongAnsweredQuestion) => +wrongAnsweredQuestion.id === +questionId)
    return foundQuestions.length > 0
  },

  getAnswerByQuestionId: (state) => (questionId) => {
    return state.answers.find((answer) => +answer.question_id === +questionId)
  },

  getCurrentQuestions: (state) => {
    if (state.followUpQuestions.length) {
      return state.followUpQuestions
    }

    const currentStepDescriptionObject = state.stepDescriptions[state.currentStep - 1] ? state.stepDescriptions[state.currentStep - 1] : null;

    if (!currentStepDescriptionObject) {
      return [];
    }
    let results = _.chain(state.questions)
      .filter((question) => {
        /*if (state.isMobile) {
          return +state.currentStep === +question.page_step_id_mobile
        }
        return +state.currentStep === +question.page_step_id_desktop*/
        return +currentStepDescriptionObject.id === + question.page_step_id_mobile
      })
      .sortBy((question) => {
        if (state.isMobile) {
          return +question.sort_order_mobile
        }
        return +question.sort_order_desktop
      })
      .value()

    return results
  },

  getTotalSteps: (state) => {
    /*let highestStepFound = 0
    let columnName = state.isMobile ? 'page_step_id_mobile' : 'page_step_id_desktop';
    if (state.questions.length > 0) {
      _.each(state.questions, (question) => {
        if (+question[columnName] > highestStepFound) {
          highestStepFound = +question[columnName]
        }
      })
    }
    return highestStepFound*/
    return state.stepDescriptions ? state.stepDescriptions.length : 0
  },
}

export default getters
